import api from "./api";

export async function fetchNotesList(params = {}) {
  const response = await api.get("/notes/notes-list", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchNoteDetail(params = {}) {
  const response = await api.get("/notes/note", { params });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}
